import {useStyles} from '../../../../shared/hooks/styles';

export default () =>
  useStyles(({isDesktop, theme, addShadow}) => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      backgroundColor: theme.color.white,
      marginBottom: 20,
      borderRadius: 24,
      ...addShadow({
        width: 0,
        height: 2,
        radius: 8,
        opacity: 0.08,
        color: theme.color.black,
        elevation: 10,
      }),
    },
    touchEnableHeader: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
    },
    header: {
      display: 'flex',
      width: '100%',
      height: isDesktop ? 125 : 62,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    title: {
      ...(isDesktop ? theme.fonts.h2 : theme.fonts.action),
      color: theme.color.gray700,
    },
    arrow: {
      transform: [{rotate: '-90deg'}],
    },
    arrowActive: {
      transform: [{rotate: '90deg'}],
    },
    description: {
      marginTop: isDesktop ? -20 : 0,
      marginBottom: 40,
    },
  }));
